import * as React from 'react';
import ValuePropText from './ValuePropText';

export default ({valuePropModalGraphic, children, bodyText, bodySubText, benefitList, bodyHeader}: ValuePropProps) => {
   return (
      <div className="modal-body value-prop-modal-body">
         {valuePropModalGraphic && <div className="value-prop-modal-graphic">{valuePropModalGraphic}</div>}
         <div className="modal-message">
            <ValuePropText bodyText={bodyText} bodyHeader={bodyHeader} bodySubText={bodySubText} benefitList={benefitList} />
         </div>
         <div className="value-prop-children">
            {children}
         </div>
      </div>
   );
};

export interface ValuePropProps {
   valuePropModalGraphic?: React.ReactNode;
   children?: React.ReactNode;
   bodyText?: string | JSX.Element;
   bodySubText?: string;
   bodyHeader?: string;
   benefitList: string[];
}